<template>
    <div class="px-1">
        <v-btn width="130px"
            x-small
            class="my-1 text-left justify-start calendar-btn"
            :dark="isDark"
            :color="btnColor.bgc"
            :class="classAttr"
            v-if="!isClosed && data"
            style="text-transform: none !important;"
            @click="btnClickHandler(data)">
            <v-tooltip top color="#000">
                <template v-slot:activator="{ on }">
                    <div v-if="processedData.holiday && isExistTypeOfHoliday(processedData.holiday.type)" :style="`fill: ${btnColor.text}`">
                        <v-icon class="mr-1" small v-on="on">${{convertTypeOfHoliday(processedData.holiday.type)}}</v-icon>
                    </div>
                    <div v-else>
                        <v-icon class="mr-1" small v-on="on" :color="btnColor.text">mdi-information</v-icon>
                    </div>
                </template>
                <div v-if="data" class="tooltip-container py-3">
                    <h4 class="text-uppercase mb-3">All records for today</h4>
                    <div class="mb-3">{{processedData.employeeName}}</div>
                    <div v-for="(item, index) in processedData.roleClinics" :key="item.roleTitle+index">
                        <strong>{{ item.roleTitle }}</strong>
                        <div v-if="item.status.length">
                            {{ item.status[0] !== ROTA_STATUSES.working ? item.status[0] : '' }}
                            <i v-if="item.status[0] === 'Off' && processedData.holiday"> * ({{holidayName}} {{processedData.holiday.details}})</i>
                        </div>
                        <div v-if="item.clinics.length">
                            <div v-for="(clinic, index) in item.clinics" :key="'clinic'+index">
                                {{ clinic }}
                            </div>
                        </div>
                        <div v-else>
                            <div v-for="(des, desIndex) in Object.keys(item.designator)" :key="item+des+desIndex">
                                <div v-if="item.designator[des].length">
                                    {{ `${des} : `}}
                                    <span v-for="(clinic, clinicIndex) in item.designator[des]" :key="clinic+clinicIndex+des">
                                        <template v-if="clinic.name">{{clinic.name}}
                                            <span class="warning--text" v-if="clinic.isTemp">(Temp)</span>
                                            <span class="warning--text">{{clinic.isExtra ? ' (Extra)' : ' (Contracted)'}}</span>
                                            <template v-if="clinicIndex < item.designator[des].length - 1">, </template>
                                        </template>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div v-if="index < processedData.roleClinics.length - 1" class="tooltip-container__border"/>
                    </div>
                    <div v-if="data.note">
                        <div class="tooltip-container__border"/>
                        <strong>Note:</strong>
                        <div>{{ data.note }}</div>
                    </div>
                </div>
            </v-tooltip>
            <span :style="`color: ${btnColor.text}`">{{processedData.employeeName | nameFilter}}</span>
        </v-btn>
        <v-btn
            width="130px"
            x-small
            class="my-1"
            color="grey lighten-2"
            v-if="isClosed"
        >Closed</v-btn>
        <div
            v-if="!isClosed && !data"
            class="text-center d-flex"
            style="background-color: transparent; width: 130px;"
        >
            <span style="width: 100%;"></span>
        </div>
    </div>
</template>

<script>
    import { ROTA_STATUSES } from '@/common/constants'
    import ROTA_COLORS from '@/constatns/rotaColors'
    import { getRoleColor } from '@/common/functions'
    import { arrayTypesHoliday, NAME_HOLIDAY_BY_KEY } from '@/constatns/typesOfHolidays'

    export default {
        name: 'CalendarActionBtn',
        props: ['data', 'rotaCLickHandler', 'isClosed'],
        data: () => ({
            ROTA_COLORS,
            ROTA_STATUSES: ROTA_STATUSES
        }),
        filters: {
            nameFilter (str = '') {
                const maxLength = 13
                if (str.length > maxLength) {
                    return str.substr(0, maxLength) + '...'
                } else {
                    return str
                }
            }
        },
        computed: {
            processedData () {
                const data = this.data
                const rota = this.$store.getters.getAllMainRota.filter(item => item.employeeId === data.employeeId && item.date === data.date)
                return {
                    ...data,
                    roleClinics: rota.reduce((acc, rotaItem) => {
                        rotaItem.records.forEach((recordItem) => {
                            let clinicText = recordItem.clinicTitle
                            if (clinicText !== '') {
                                if (recordItem.surgeryTitle) {
                                    clinicText += ' - ' + recordItem.surgeryTitle
                                }
                                const isRoleAdded = acc.find(role => role.roleTitle === recordItem.roleTitle)
                                if (isRoleAdded) {
                                    if (clinicText && !isRoleAdded.designator[recordItem.designator].find(item => item.name === clinicText)) {
                                        isRoleAdded.designator[recordItem.designator].push({
                                            name: clinicText,
                                            isTemp: recordItem.isTemp,
                                            isExtra: recordItem.isExtra
                                        })
                                    }
                                    if (!isRoleAdded.status.find(st => st === recordItem.status)) {
                                        isRoleAdded.status.push(recordItem.status)
                                    }
                                } else {
                                    acc.push({
                                        roleTitle: recordItem.roleTitle,
                                        designator: {
                                            AM: recordItem.designator === 'AM' && clinicText ? [{
                                                name: clinicText,
                                                isTemp: recordItem.isTemp,
                                                isExtra: recordItem.isExtra
                                            }] : [],
                                            PM: recordItem.designator === 'PM' && clinicText ? [{
                                                name: clinicText,
                                                isTemp: recordItem.isTemp,
                                                isExtra: recordItem.isExtra
                                            }] : []
                                        },
                                        clinics: [],
                                        status: (recordItem.status === ROTA_STATUSES.off || recordItem.status === ROTA_STATUSES.spare) ? [recordItem.status] : []
                                    })
                                }
                            }
                        })
                        return acc
                    }, [])
                }
            },
            btnText () {
                if (this.data.status === ROTA_STATUSES.working) {
                    return this.processedData.clinicTitle
                } else {
                    return this.data.status
                }
            },
            isSelected () {
                const item = this.data
                return !!this.$store.getters.getMainRotaSelected.find(selectedItem => {
                    if (item.id) {
                        return selectedItem.id === item.id
                    }
                    if (item.employeeDefaultRotaDayId) {
                        return selectedItem.employeeDefaultRotaDayId === item.employeeDefaultRotaDayId
                    }
                })
            },
            btnColor () {
                const color = getRoleColor(this.data.roleId)
                if (color) {
                    return color
                } else {
                    return {
                        bgc: ROTA_COLORS.DEFAULT,
                        text: '#fff'
                    }
                }
            },
            disabled () {
                return Date.checkIsPastDate(this.data.date)
            },
            classAttr () {
                let classStr = ''
                classStr += this.isSelected ? 'primary lighten-2' : ''
                if (this.disabled) {
                    classStr += ' btn-disabled'
                }
                if (this.data.note) classStr += ' btn-has-note'
                return classStr
            },
            isDark () {
                return ROTA_COLORS.DEFAULT !== this.btnColor
            },
            holidayName: function () {
                return NAME_HOLIDAY_BY_KEY[this.processedData.holiday.type.split(' ').join('')]
            }
        },
        methods: {
            btnClickHandler (item) {
                if (this.disabled) {
                    return false
                }
                item.selected = this.isSelected
                this.$store.dispatch('selectMainRota', item)
            },
            isExistTypeOfHoliday (holiday) {
                return arrayTypesHoliday.some((item) => item.value === holiday.split(' ').join(''))
            },
            convertTypeOfHoliday (typeOfHoliday) {
                return typeOfHoliday.toLowerCase().split(' ').join('')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .calendar-btn {
        position: relative;
        &.btn-disabled {
            color: #8a8a8a !important;
        }
        &.btn-has-note:after {
            content: '';
            position: absolute;
            width: 10px;
            height: 10px;
            background: #6C9D39;
            border-radius: 50%;
            right: -5px;
            top: -5px;
            left: unset;
        }
    }

    .tooltip-container {
        &__border {
            border-bottom: 1px dashed #ffffff;
            border-top: none;
            border-left: none;
            border-right: none;
            margin: 15px 0;
            display: block;
        }
    }
</style>
